import ElementContent from '@/components/sections/builder/elements/body/blog-detail/content';
import BlogDetailTitle from '@/components/sections/builder/elements/body/blog-detail/title';
import BlogDetailContent from '@/components/sections/builder/elements/body/blog-detail/content/index';
import BlogFeaturedImage from '@/components/sections/builder/elements/body/blog-detail/featured_image';
import ElementSetting from '@/components/sections/builder/elements/body/blog-detail/setting';
import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import { Type } from 'lucide-react';

const defaultData: BlogDetailTitleElementDataType = {
  name: 'Blogs Detail',
  padding: {
    top: 20,
    bottom: 20,
    left: 0,
    right: 0,
  },
};

export const ElementPreviewIcon = Type;

const BlogsDetail = {
  type: 'blog_detail',
  group: 'body_blog_detail',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [BlogDetailTitle, BlogDetailContent],
  childs: [BlogFeaturedImage, BlogDetailTitle, BlogDetailContent],
  maxEntries: 1,
  isImmutable: true,
};

export default BlogsDetail;
